export default __webpack_public_path__ + "static/media/mastered-new.a405ce85.svg";